'use strict';
import React from 'react';

var HtmlViewer = React.createClass({
    displayName: 'HtmlViewer',

    getInitialState: function () {
        this.getHtml(this.props.url);
        return {
            __html: ""
          }
    },

    componentWillReceiveProps(nextProps) {
        if (this.props.url != nextProps.url) {
            this.setState(this.getHtml(nextProps.url));
        }
    },

    getHtml: function (url) {
        fetch(url, {
            method: 'GET',
        })
        .then((response) => response.text())
        .then(text => {
            try {
                var parser = new DOMParser();
                var htmlDoc = parser.parseFromString(text, "text/html");
                // var bodyHtml = /<body.*?>([\s\S]*)<\/body>/.exec(htmlDoc)[1];
                this.setState({
                    __html: htmlDoc.body.innerHTML
                  });
            } catch (err) {
                console.log('Error getHtml: ' + err);
                this.setState({
                    __html: ""
                  });
            }
        });
    },

    render() {
        return (
            <div className="html__wrapper" dangerouslySetInnerHTML={this.state} />
        )
    }
});

module.exports = HtmlViewer;


// WEBPACK FOOTER //
// ./app/components/htmlViewer/htmlViewer.jsx